import React, { useEffect } from 'react'
import { Team } from '../components/chat/team'
import { Modals } from '../components/modals'
import { Drawers } from '../components/drawers'
import { useGeneral } from '../stores/useGeneral'

const TeamPage = ({light}) =>{
  const {setMode} = useGeneral(state=>state)
  useEffect(()=>{
    light && setMode('light')
 },[])
  document.head.querySelector('title').text = 'Team Hype5 React Chat Platform'
  return (
    <React.Fragment>
        <Team />
        <Modals/>
        <Drawers/>
    </React.Fragment>
  )
}
export default TeamPage